import {cropText} from "@/core/utils/helpers/textHelpers";

export default {
    computed: {
        isVenueOrIncall() {
            return this.userProp.is_venue || Number(this.userProp.meeting_location) === constants.meeting_location.INCALL;
        },
        outCallDistance() {
            const translateKey = this.isVenueOrIncall ? 'venueFoundByOutcallLocation' : 'foundByOutcallLocation';
            return this.getOutCallDistanceTranslation(translateKey);
        },
        outCallDistanceHTML() {
            const translateKey = this.isVenueOrIncall ? 'venueFoundByOutcallLocationHTML' : 'foundByOutcallLocationHTML';
            return this.getOutCallDistanceTranslation(translateKey);
        },
    },
    methods: {
        cropText,
        getOutCallDistanceTranslation(translateKey) {
            const city = _.get(this.userProp, 'override_postcode_part_post_town_from_suburb') || this.userProp.city;

            return this.fillTranslateParams(this.translate.home[translateKey], {
                city: cropText(city, this.maxCityLength),
                distance: `${this.userProp.outcall_distance}km`
            });
        },
    },
}
